import { Banner, Breadcrumbs, Empty, Loader, LinkButton, Text } from '@cloudflare/kumo'
import { HouseIcon, UserPlusIcon, UsersIcon } from '@phosphor-icons/react'
import { useTranslation } from '../i18n'
import { PageHeader } from '../components/kumo/page-header/page-header'
import { RecentGuestsList } from '../components/guests/RecentGuestsList'
import { UpcomingInvitations } from '../components/guests/UpcomingInvitations'
import { useGuestData } from '../components/guests/useGuestData'
import { useNow } from '../components/guests/useNow'
import '../components/guests/guests.css'

/** `/my/guests`: upcoming invitations by day, recent guests, and the way to a new invitation. */
export function GuestInvitationsPage() {
  const { t } = useTranslation()
  const data = useGuestData({ invitations: true })
  const now = useNow()

  return (
    <div>
      <PageHeader
        breadcrumbs={
          <Breadcrumbs>
            <Breadcrumbs.Link icon={<HouseIcon size={14} />} href="/">
              {t('nav.home')}
            </Breadcrumbs.Link>
            <Breadcrumbs.Separator />
            <Breadcrumbs.Current>{t('guestInvitations.title')}</Breadcrumbs.Current>
          </Breadcrumbs>
        }
        title={t('guestInvitations.title')}
        description={t('guestInvitations.description')}
      />

      <div className="guest-list">
        <div className="guest-list__cta">
          <LinkButton
            href="/my/guests/new"
            variant="primary"
            className="guest-btn"
            icon={<UserPlusIcon size={18} />}
          >
            {t('guestInvitations.list.invite')}
          </LinkButton>
        </div>

        {data.loading && (
          <div className="flex items-center justify-center py-16">
            <Loader size="lg" />
          </div>
        )}

        {!data.loading && data.error && (
          <Banner variant="error">
            {t('common.errorPrefix')}{' '}
            {data.error === 'GENERIC_ERROR' ? t('common.error') : data.error}
          </Banner>
        )}

        {!data.loading && !data.error && (
          <>
            <section aria-labelledby="guests-upcoming" className="flex flex-col gap-3">
              <Text as="h2" variant="heading3" id="guests-upcoming">
                {t('guestInvitations.list.title')}
              </Text>
              <UpcomingInvitations
                invitations={data.invitations}
                bookings={data.bookings}
                timeZone={data.timeZone}
                now={now}
              />
            </section>

            <section aria-labelledby="guests-recent" className="flex flex-col gap-3">
              <Text as="h2" variant="heading3" id="guests-recent">
                {t('guestInvitations.recent.title')}
              </Text>
              {data.recent.length === 0 ? (
                <Empty
                  size="sm"
                  icon={<UsersIcon size={32} className="text-kumo-inactive" />}
                  title={t('guestInvitations.recent.empty')}
                  description={t('guestInvitations.recent.emptyDescription')}
                />
              ) : (
                <RecentGuestsList guests={data.recent} />
              )}
            </section>
          </>
        )}
      </div>
    </div>
  )
}
